import { useQuery, useQueryClient } from '@tanstack/react-query';

import * as qaSpecServices from 'services/qaSpec';

export const getMasterCaseKey = (productId) => {
  return [
    'qa-spec',
    parseInt(productId),
    'qa-master-case',
  ];
};

export const useGetPackagingMasterCaseQuery = ({ productId }) => {
  const queryClient = useQueryClient();

  const { data, ...rest } = useQuery({
    queryKey: getMasterCaseKey(productId),
    queryFn: async () => {
      return await qaSpecServices.getQaSpecMasterCase({
        productId,
      });
    },
    enabled: Boolean(productId),
  });

  const handleRefetchMasterCase = () => {
    queryClient.invalidateQueries({
      queryKey: getMasterCaseKey(productId),
    });
  };
 
  return {
    packagingData: data?.data,
    handleRefetchMasterCase,
    ...rest,
  };
};
